export default __webpack_public_path__ + "static/media/youtube.6e748307.svg";